<template>
  <div class="cancel">
    <div class="block">
      <p class="block-p"><span style="color:skyblue">1. </span>打开“微信”APP</p>
      <img class="one img" src="../assets/cosleep_guidance_img_subscribe-wechat1_cn@3x.png"/>
    </div>
    <div class="block">
      <p class="block-p"><span style="color:skyblue">2. </span>点击【我】-【钱包】</p>
      <img class="two img" src="../assets/cosleep_guidance_img_subscribe-wechat2_cn@3x.png"/>
    </div>
    <div class="block">
      <p class="block-p"><span style="color:skyblue">3. </span>点击右上角图标进入【支付中心】</p>
      <img class="two img" src="../assets/cosleep_guidance_img_subscribe-wechat3_cn@3x.png"/>
    </div>
    <div class="block">
      <p class="block-p"><span style="color:skyblue">4. </span>在支付中心页面点击【支付管理】</p>
      <img class="two img" src="../assets/cosleep_guidance_img_subscribe-wechat4_cn@3x.png"/>
    </div>
    <div class="block">
      <p class="block-p"><span style="color:skyblue">5. </span>点击【自动扣费】</p>
      <img class="two img" src="../assets/cosleep_guidance_img_subscribe-wechat5_cn@3x.png"/>
    </div>
    <div class="block">
      <p class="block-p"><span style="color:skyblue">6. </span>选择小睡眠</p>
      <img class="two img" src="../assets/cosleep_guidance_img_subscribe-wechat6_cn@3x.png"/>
    </div>
    <div class="block">
      <p class="block-p"><span style="color:skyblue">7. </span>点击【关闭服务】</p>
      <img class="two img" src="../assets/cosleep_guidance_img_subscribe-wechat7_cn@3x.png"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cancel',
  mounted () {
    document.title = '安卓取消连续包月'
  }
}
</script>

<style lang="scss" scoped>
.cancel {
    font-family: Noto Sans CJK SC Regular;
    font-size: px2html(14px);
    box-sizing: border-box;
    margin-top: px2html(20px);
    padding-left: px2html(21px);
    padding-right: px2html(21px);
  .block {
    text-align: left;
    position: relative;
    margin-bottom: px2html(30px);
  }
  .img {
    margin-top: px2html(10px);
    position: relative;
    right: px2html(-20px);
  }
  .one {
    width: px2html(60px);
    height: px2html(75px);
  }
  .two {
    width: px2html(140px);
    height: px2html(231px);
  }
}
</style>
